<div oui-dialog-title>
  @if (!isLoading) {
    Avez-vous bien ajouté tous les documents ?
  }
  @if (isLoading) {
    Déclaration en cours
  }
  @if (!isLoading) {
    <oui-button type="icon" oui-dialog-close>
      <oui-icon>close</oui-icon>
    </oui-button>
  }
</div>

<oui-dialog-content>
  @if (isLoading) {
    <oui-loading class="loader" size="small"></oui-loading>
  }
  @if (!isLoading) {
    <div [innerHTML]="message"></div>
    @if (hasOutdatedDocumentsWarning) {
      <oui-banner
        class="outdated-documents-warning"
        declination="alert"
        title="Attention des documents de la connaissance client existent dans une version plus récente"
        [action]="bannerSeeOutdatedDocumentsAction"
      [showCloseButton]="false"></oui-banner>
    }
    <oui-banner
      title="Vous n'avez pas besoin d'envoyer un email à Stellium Placement après votre déclaration"
    [showCloseButton]="false"></oui-banner>
  }
</oui-dialog-content>

@if (!isLoading) {
  <oui-dialog-actions>
    <oui-button type="text" oui-dialog-close>Annuler</oui-button>
    <oui-button type="contained" (click)="declareOperation()">{{
      hasOutdatedDocumentsWarning ? 'Déclarer quand même' : 'Déclarer'
    }}</oui-button>
  </oui-dialog-actions>
}
